import { useState } from "react";
import api from "../../services/api";

export default function MateriaalToevoegenModal({ werkbonId, onClose, onSave }) {
  const [form, setForm] = useState({
    naam: "",
    artikelnummer: "",
    leverancier: "",
    leverancierArtikelnummer: "",
    hoeveelheid: 1,
    uitGrijpvoorraad: false,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");

    try {
      const qty = Number(form.hoeveelheid || 0);
      if (!form.naam || !Number.isFinite(qty) || qty <= 0) {
        throw new Error("Vul minimaal naam en geldige hoeveelheid in.");
      }

      const finRes = await api.get(`/werkbonnen/${werkbonId}/financial`);
      const existing = Array.isArray(finRes?.data?.materialEntries) ? finRes.data.materialEntries : [];

      const next = [
        ...existing.map((entry) => ({
          datum: entry.datum,
          description: entry.description || "",
          qty: Number(entry.qty || 0),
          unit: entry.unit || "st",
          articleCode: entry.articleCode || "",
          supplier: entry.supplier || "",
          supplierArticleNumber:
            entry.supplierArticleNumber || entry.articleCode || "",
          billable: entry.billable !== false,
          unitSell: Number(entry.unitSell || 0),
          unitCost: Number(entry.unitCost || 0),
          vatRate: Number(entry.vatRate ?? 21),
        })),
        {
          description: form.naam,
          qty,
          unit: "st",
          articleCode: form.artikelnummer || "",
          supplier: form.leverancier || "",
          supplierArticleNumber:
            form.leverancierArtikelnummer || form.artikelnummer || "",
          billable: true,
          unitSell: 0,
          unitCost: 0,
          vatRate: 21,
        },
      ];

      await api.put(`/werkbonnen/${werkbonId}/material-entries`, { materialEntries: next });
      onSave?.();
      onClose();
    } catch (err) {
      console.error("Materiaal toevoegen fout:", err);
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Er ging iets mis bij het opslaan van het materiaal."
      );
    }

    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white border border-gray-300 shadow-xl p-6 rounded-sm w-96">

        <h2 className="text-xl font-semibold text-blue-700 mb-4">
          Materiaal toevoegen
        </h2>

        <div className="space-y-3">

          <div>
            <label className="block text-sm font-medium">Naam</label>
            <input
              type="text"
              name="naam"
              value={form.naam}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2"
              placeholder="Bijv. rookmelder"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Artikelnummer</label>
            <input
              type="text"
              name="artikelnummer"
              value={form.artikelnummer}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2"
              placeholder="Bijv. 7002435"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Leverancier</label>
            <input
              type="text"
              name="leverancier"
              value={form.leverancier}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2"
              placeholder="Bijv. Technische Unie"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Leverancier artikelnummer</label>
            <input
              type="text"
              name="leverancierArtikelnummer"
              value={form.leverancierArtikelnummer}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2"
              placeholder="Bijv. TU-7002435"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Hoeveelheid</label>
            <input
              type="number"
              min="1"
              name="hoeveelheid"
              value={form.hoeveelheid}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2"
            />
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              name="uitGrijpvoorraad"
              checked={form.uitGrijpvoorraad}
              onChange={handleChange}
              className="mr-2"
            />
            <label className="text-sm font-medium">
              Uit grijpvoorraad
            </label>
          </div>

          {error && <p className="text-red-600 text-sm">{error}</p>}

        </div>

        <div className="mt-5 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 border border-gray-500"
          >
            Annuleren
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white border border-blue-800"
          >
            {loading ? "Opslaan..." : "Opslaan"}
          </button>
        </div>

      </div>
    </div>
  );
}
